var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 19.5384,
    r: 19.5384,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1668 24.8331C12.1668 25.2752 12.3423 25.699 12.655 26.0117C12.9675 26.3242 13.3914 26.4998 13.8334 26.4998H27.167C27.6089 26.4998 28.0329 26.3242 28.3454 26.0117C28.658 25.699 28.8335 25.2752 28.8335 24.8331V18.1667C28.8335 17.7246 28.658 17.3007 28.3454 16.9881C28.0329 16.6756 27.6089 16.5 27.167 16.5H20.1834L18.1417 12.425C18.0037 12.1473 17.7911 11.9137 17.5276 11.7503C17.264 11.5868 16.9602 11.5001 16.6501 11.5H13.8334C13.3914 11.5 12.9675 11.6756 12.655 11.9881C12.3423 12.3008 12.1668 12.7246 12.1668 13.1667V24.8331Z",
    fill: "#D9A30E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0333 12.3333L20.7 15.6665L26.3332 15.6667V14C26.3332 13.558 26.1577 13.134 25.8451 12.8214C25.5326 12.5089 25.1086 12.3333 24.6666 12.3333L19.0333 12.3333Z",
    fill: "#D9A30E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/foldericon.666d2e635331143234843f1fe462e8c3.svg";
export { ForwardRef as ReactComponent };